import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
import {POLL_STATUS_FINISHED, POLL_STATUS_OPEN} from '@/constants'

import RespListPage from '@/pages/Resp/List.vue'
import RespPage from '@/pages/Resp/Page.vue'
import respListComponent from '@/components/Resp/respList.vue'
import {RouteConfig} from 'vue-router'

import blankList from '@/components/Resp/list/blank.vue'
import filledList from '@/components/Resp/list/filled.vue'

// @ts-ignore
import messages from '@/lang/index'

const resp: RouteConfig = {
  path: '/resp',
  name: 'resp',
  meta: {
    pageName: messages.polls.polls
  },
  component: DashboardLayout,
  redirect: '/resp/list',
  children: [
    {
      path: 'list',
      name: 'respList',
      meta: {
        pageName: messages.polls.polls_list
      },
      component: RespListPage,
      redirect: {name: 'respBlankList'},
      children: [
        {
          path: 'blank',
          name: 'respBlankList',
          meta: {
            pageName: messages.polls.poll_active
          },
          component: blankList,
          props: { active: true }
        },
        {
          path: 'filled',
          name: 'respFilledList',
          meta: {
            pageName: messages.polls.poll_filled
          },
          component: filledList,
          props: { active: false }
        }
      ]
    },
    {
      path: ':id',
      name: 'respPage',
      meta: {
        pageName: messages.polls.poll
      },
      component: RespPage,
      props: true
    }
  ]
}

export default resp